package com.steamstreet.vegasful.browser

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers

val appScope = CoroutineScope(Dispatchers.Default)